import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TVehiculeCheckEmailSchema } from '@/schemas/vehicule-check-email/vehicule-check-email.schema';
import { useGetAllVehiculeCheckEmails } from '@/hooks/vehicule-check-email.hooks';
import Card from '@/components/Card';
import { VehiculeCheckEmailTableView } from './VehiculeCheckEmailTableView';
import { VehiculeCheckEmailTableData } from './VehiculeCheckEmailTableData';
import { VehiculeCheckEmailTableHeaders } from './VehiculeCheckEmailTableHeaders';

export const VehiculeCheckEmailList = () => {
  const { t } = useTranslation('vehiculeCheckEmail');
  const { id } = useParams();

  return (
    <>
      <Card title="Emails envoyés">
        <VehiculeCheckEmailTableView<TVehiculeCheckEmailSchema>
          t={t}
          id={id}
          useGetAllData={useGetAllVehiculeCheckEmails}
          tableHeaders={VehiculeCheckEmailTableHeaders}
          tableData={VehiculeCheckEmailTableData}
        />
      </Card>
    </>
  );
};
